import { useId, type TextareaHTMLAttributes } from 'react';

import { cn } from '../../lib/cn';
import styles from './Textarea.module.css';

export type TextareaProps = {
  readonly label?: string;
  readonly error?: string | null;
  readonly hint?: string;
} & Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'className'>;

export function Textarea({ label, error, hint, id, rows = 3, ...rest }: TextareaProps) {
  const generatedId = useId();
  // Как и у `Input`: без своего id несколько полей делили `id="textarea"`,
  // и подпись ссылалась на чужое поле.
  const textareaId = id ?? rest.name ?? generatedId;
  const describedBy = error ? `${textareaId}-error` : hint ? `${textareaId}-hint` : undefined;

  return (
    <div className={styles['field']}>
      {label ? (
        <label className={styles['label']} htmlFor={textareaId}>
          {label}
        </label>
      ) : null}
      <textarea
        {...rest}
        id={textareaId}
        rows={rows}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        className={cn(styles['textarea'], error && styles['invalid'])}
      />
      {error ? (
        <p className={styles['error']} id={`${textareaId}-error`} role="alert">
          {error}
        </p>
      ) : hint ? (
        <p className={styles['hint']} id={`${textareaId}-hint`}>
          {hint}
        </p>
      ) : null}
    </div>
  );
}
